import { useState } from 'react';
import { DataTableActions } from 'src/components/DataTable';
import { CellProps, Row } from 'src/components/DataTable/types';
import { SiteDeviceProjectItem } from '../../types';
import NameSpacePodsModal from './components/NameSpacePodsModal';

function NameSpacesListAction({ item }: CellProps<any, Row>) {
  const row = item as unknown as SiteDeviceProjectItem;
  const [open, setOpen] = useState(false);

  return (
    <>
      <DataTableActions
        canView={true}
        showEdit={false}
        showDelete={false}
        showView={true}
        onView={() => setOpen(true)}
      />
      {open && (
        <NameSpacePodsModal
          open={open}
          onClose={() => setOpen(false)}
          namespaceName={row?.nameSpace ?? ''}
          pods={row?.pods ?? []}
        />
      )}
    </>
  );
}

export default NameSpacesListAction;
